window.ACTICLEAR_CATALOG = {
  "capturedAt": "2026-09-21T02:59:34.754720+00:00",
  "currency": "USD",
  "priceUnit": "minor-unit-cent",
  "products": [
    {
      "id": "compact",
      "shopifyProductId": 9270547677430,
      "handle": "muck-clear-natural-pond-sludge-treatment",
      "name": "Muck Clear Compact",
      "sourceTitle": "Acticlear Muck Clear – Natural Pond Sludge Treatment",
      "category": "pond",
      "image": "assets/muck-compact-cutout.png",
      "status": "active",
      "variants": [
        {
          "id": 49913176064246,
          "title": "0.5lb / 1 pack",
          "options": [
            "0.5lb",
            "1 pack"
          ],
          "price": 1299,
          "available": true,
          "sourceImage": "https://cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1_c072d483-7493-432a-b37b-10e5d30b2c77.jpg?v=1773043802"
        },
        {
          "id": 49913176097014,
          "title": "1lb / 1 pack",
          "options": [
            "1lb",
            "1 pack"
          ],
          "price": 2199,
          "available": true,
          "sourceImage": "https://cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1.1_4dc11638-71ae-418f-a74f-3ac8ec5c377f.jpg?v=1773043802"
        },
        {
          "id": 49913176129782,
          "title": "2lb / 1 pack",
          "options": [
            "2lb",
            "1 pack"
          ],
          "price": 3299,
          "available": true,
          "sourceImage": "https://cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1.2.jpg?v=1773043802"
        },
        {
          "id": 50113861353718,
          "title": "4lb / 1 pack",
          "options": [
            "4lb",
            "1 pack"
          ],
          "price": 4999,
          "available": true,
          "sourceImage": "https://cdn.shopify.com/s/files/1/0792/6585/7782/files/71bUIlu-IqL._AC_SX679.jpg?v=1773709593"
        }
      ],
      "source": "https://www.acticlear.co/products/muck-clear-natural-pond-sludge-treatment",
      "currency": "USD",
      "priceUnit": "minor-unit-cent",
      "representativeImage": {
        "label": "0.5lb (label Net Wt. 8oz / 225g)",
        "appliesToAllVariants": false,
        "note": "Representative package image; selected size may have different packaging. No size-specific image swap is implied."
      },
      "sourceUse": "Pond sludge treatment; follow matching package directions.",
      "sourceEvidence": {
        "productJSON": "reference/catalog/muck-clear-natural-pond-sludge-treatment.json",
        "productHTML": "reference/catalog/muck-clear-natural-pond-sludge-treatment.html",
        "sourceDescriptionHTML": "<h5 class=\"a-size-large a-spacing-none linkfox-amz-hover-target\">\n<strong data-start=\"476\" data-end=\"519\"><span class=\"BZ_Pyq_fadeIn\">ActiClear  Muck Clear</span></strong><span class=\"BZ_Pyq_fadeIn\"> </span><span class=\"BZ_Pyq_fadeIn\">help </span><span class=\"BZ_Pyq_fadeIn\">break </span><span class=\"BZ_Pyq_fadeIn\">down </span><span class=\"BZ_Pyq_fadeIn\">muck, </span><span class=\"BZ_Pyq_fadeIn\">sludge, </span><span class=\"BZ_Pyq_fadeIn\">and </span><span class=\"BZ_Pyq_fadeIn\">organic </span><span class=\"BZ_Pyq_fadeIn\">buildup </span><span class=\"BZ_Pyq_fadeIn\">with </span><strong data-start=\"575\" data-end=\"610\"><span class=\"BZ_Pyq_fadeIn\">beneficial </span><span class=\"BZ_Pyq_fadeIn\">bacteria </span><span class=\"BZ_Pyq_fadeIn\">and </span><span class=\"BZ_Pyq_fadeIn\">enzymes</span></strong><span class=\"BZ_Pyq_fadeIn\">. </span><span class=\"BZ_Pyq_fadeIn\">Ideal </span><span class=\"BZ_Pyq_fadeIn\">for </span><strong data-start=\"622\" data-end=\"669\"><span class=\"BZ_Pyq_fadeIn\">ponds, </span><span class=\"BZ_Pyq_fadeIn\">fountains, </span><span class=\"BZ_Pyq_fadeIn\">koi </span><span class=\"BZ_Pyq_fadeIn\">ponds, </span><span class=\"BZ_Pyq_fadeIn\">and </span><span class=\"BZ_Pyq_fadeIn\">bird </span><span class=\"BZ_Pyq_fadeIn\">baths</span></strong><span class=\"BZ_Pyq_fadeIn\">, </span><span class=\"BZ_Pyq_fadeIn\">and </span><span class=\"BZ_Pyq_fadeIn\">safe </span><span class=\"BZ_Pyq_fadeIn\">for </span><strong data-start=\"684\" data-end=\"712\"><span class=\"BZ_Pyq_fadeIn\">fish, </span><span class=\"BZ_Pyq_fadeIn\">pets, </span><span class=\"BZ_Pyq_fadeIn\">and </span><span class=\"BZ_Pyq_fadeIn\">wildlife</span></strong><span class=\"BZ_Pyq_fadeIn\">.</span>\n</h5>",
        "sourceImages": [
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1_c072d483-7493-432a-b37b-10e5d30b2c77.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1.1_4dc11638-71ae-418f-a74f-3ac8ec5c377f.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1.2.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_2_d6bee5b2-8519-43aa-99ac-4738e465e178.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_3_04abe4d5-819b-4b4c-a772-bfbb2df324b2.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_4_001f22f9-206d-402e-8513-904bbdbeaa4a.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_5_bad972af-d8ad-4b44-a38d-ca773d1aa063.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_6_b3e6ce26-61de-44d8-800b-e3fd60743d75.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_7_07779969-b18d-4b5f-a271-d88621efe1fd.jpg?v=1773043802",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/71bUIlu-IqL._AC_SX679.jpg?v=1773709593"
        ],
        "variantImageIds": {
          "49913176064246": 46280653308150,
          "49913176097014": 46280647573750,
          "49913176129782": 46280647606518,
          "50113861353718": 46331519205622
        }
      }
    },
    {
      "id": "large",
      "shopifyProductId": 9270559604982,
      "handle": "muck-clear-beneficial-bacteria",
      "name": "Muck Clear Large",
      "sourceTitle": "ActiClear Muck Clear - Beneficial Bacteria for Ponds & Lakes",
      "category": "pond",
      "image": "assets/muck-large-cutout.png",
      "status": "active",
      "variants": [
        {
          "id": 49913279021302,
          "title": "5lb / 1 pack",
          "options": [
            "5lb",
            "1 pack"
          ],
          "price": 4299,
          "available": true,
          "sourceImage": null
        },
        {
          "id": 49913279054070,
          "title": "15lb / 1 pack",
          "options": [
            "15lb",
            "1 pack"
          ],
          "price": 9999,
          "available": true,
          "sourceImage": null
        }
      ],
      "source": "https://www.acticlear.co/products/muck-clear-beneficial-bacteria",
      "currency": "USD",
      "priceUnit": "minor-unit-cent",
      "representativeImage": {
        "label": "5lb pail representative artwork. Verified 15lb raw front is a carton; do not describe all sizes as pails.",
        "appliesToAllVariants": false,
        "note": "Representative package image; selected size may have different packaging. No size-specific image swap is implied."
      },
      "sourceUse": "Pond and lake care; follow matching package directions.",
      "sourceEvidence": {
        "productJSON": "reference/catalog/muck-clear-beneficial-bacteria.json",
        "productHTML": "reference/catalog/muck-clear-beneficial-bacteria.html",
        "sourceDescriptionHTML": "<h3>Clean Water. Healthy Life.</h3><p>Restore the natural balance of your pond or lake. Our professional-grade blend of beneficial bacteria and enzymes digests organic muck and sludge at the source, resulting in crystal-clear water and a thriving ecosystem.</p><div class=\"product-features\">\n<h4>Why You’ll Love It:</h4>\n<ul>\n<li>\n<strong>Eliminates Muck:</strong> Breaks down leaf litter, fish waste, and organic debris.</li>\n<li>\n<strong>Clears Water:</strong> Reduces suspended particles for maximum clarity.</li>\n<li>\n<strong>Fish &amp; Pet Safe:</strong> 100% biological formula—harmless to wildlife and pets.</li>\n<li>\n<strong>Odors Be Gone:</strong> Targets the root cause of pond smells for a fresher environment.</li>\n</ul>\n</div><div class=\"how-to-use\">\n<h4>How to Use:</h4>\n<ol>\n<li>Distribute the powder evenly across the water surface or targeted areas.</li>\n<li>Repeat every 4 weeks or as needed based on muck accumulation.</li>\n</ol>\n</div>",
        "sourceImages": [
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1_88f35798-9222-4816-ac9b-8afa49ab82c6.jpg?v=1776243099"
        ],
        "variantImageIds": {
          "49913279021302": null,
          "49913279054070": null
        }
      }
    },
    {
      "id": "oil",
      "shopifyProductId": 9270543417590,
      "handle": "cooking-oil-solidifier",
      "name": "Cooking Oil Solidifier",
      "sourceTitle": "ActiClear Eco-Friendly Cooking Oil Solidifier - Turns Fry Oil into Bio-Waste (22oz)",
      "category": "kitchen",
      "image": "assets/oil-solidifier-cutout.png",
      "status": "active",
      "variants": [
        {
          "id": 49913164497142,
          "title": "11oz / 1 pack",
          "options": [
            "11oz",
            "1 pack"
          ],
          "price": 999,
          "available": true,
          "sourceImage": null
        },
        {
          "id": 49913164529910,
          "title": "22oz / 1 pack",
          "options": [
            "22oz",
            "1 pack"
          ],
          "price": 1499,
          "available": true,
          "sourceImage": null
        }
      ],
      "source": "https://www.acticlear.co/products/cooking-oil-solidifier",
      "currency": "USD",
      "priceUnit": "minor-unit-cent",
      "representativeImage": {
        "label": "22oz representative artwork; do not imply 11oz is this same physical pack",
        "appliesToAllVariants": false,
        "note": "Representative package image; selected size may have different packaging. No size-specific image swap is implied."
      },
      "sourceUse": "For handling used cooking oil with a solidifier; follow matching package directions.",
      "sourceEvidence": {
        "productJSON": "reference/catalog/cooking-oil-solidifier.json",
        "productHTML": "reference/catalog/cooking-oil-solidifier.html",
        "sourceDescriptionHTML": "<h3>Magic in Minutes. Clean in One Step.</h3><p>Say goodbye to greasy drains and messy containers. Our algae-based solidifier transforms used cooking oil into a firm, solid waste you can simply toss in the trash. No spills, no clogs, just pure bio-based magic.</p><div class=\"product-features\">\n<h4>Why You’ll Love It:</h4>\n<ul>\n<li>\n<strong>Easy to Use:</strong> Just stir into hot oil (170°F+), let cool, and watch it solidify.</li>\n<li>\n<strong>Algae-Based Formula:</strong> 100% plant-derived, non-toxic, and biodegradable. Safe for pipes and the planet.</li>\n<li>\n<strong>Mess-Free Cleanup:</strong> Turns liquid grease into a scoopable solid. No more pouring oil into jars or drains.</li>\n<li>\n<strong>Large Capacity:</strong> One 22oz bag treats up to 4.4 gallons (64 cups) of oil.</li>\n</ul>\n</div><div class=\"how-to-use\">\n<h4>How to Use:</h4>\n<ol>\n<li>Turn off heat. Ensure oil is at least 170°F.</li>\n<li>Sprinkle ActiClear powder into the oil.</li>\n<li>Stir until completely dissolved.</li>\n<li>Wait for the oil to cool and solidify (time varies by volume).</li>\n<li>Scoop out the solid waste and toss it in the trash.</li>\n</ol>\n</div><div class=\"faq-brief\">\n<h4>FAQs:</h4>\n<p><strong>Is it safe?</strong> Yes, it’s non-toxic and chemical-free. Safe for kids, pets, and waterways.</p>\n<p><strong>Does it work on animal fats?</strong> It works best with vegetable oils like canola, sunflower, or soybean.</p>\n</div>",
        "sourceImages": [
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/41jc3_vemUL.jpg?v=1776242274",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/51-1fl6YgML.jpg?v=1776242274",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/512-NXnf0KL.jpg?v=1776242274",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/51z1xYp-UUL.jpg?v=1776242274",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/510DM22u12L.jpg?v=1776242274",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/512rW0bHQLL.jpg?v=1776242274",
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/71HaYfT9pCL.jpg?v=1776242274"
        ],
        "variantImageIds": {
          "49913164497142": null,
          "49913164529910": null
        }
      }
    },
    {
      "id": "pee",
      "shopifyProductId": 9270559867126,
      "handle": "pee-powder-gel",
      "name": "Pee Powder",
      "sourceTitle": "ActiClear Portable Toilet Pee Powder - Rapid 60-Second Absorption & Odor Neutralizer",
      "category": "travel",
      "image": "assets/pee-powder-cutout.png",
      "status": "active",
      "variants": [
        {
          "id": 49913285345526,
          "title": "2lb / 1 pack",
          "options": [
            "2lb",
            "1 pack"
          ],
          "price": 2199,
          "available": true,
          "sourceImage": null
        },
        {
          "id": 49913285378294,
          "title": "4lb / 1 pack",
          "options": [
            "4lb",
            "1 pack"
          ],
          "price": 3999,
          "available": true,
          "sourceImage": null
        }
      ],
      "source": "https://www.acticlear.co/products/pee-powder-gel",
      "currency": "USD",
      "priceUnit": "minor-unit-cent",
      "representativeImage": {
        "label": "4lb (label Net WT 4LB)",
        "appliesToAllVariants": false,
        "note": "Representative package image; selected size may have different packaging. No size-specific image swap is implied."
      },
      "sourceUse": "Portable toilet / liquid-waste handling; follow matching package directions.",
      "sourceEvidence": {
        "productJSON": "reference/catalog/pee-powder-gel.json",
        "productHTML": "reference/catalog/pee-powder-gel.html",
        "sourceDescriptionHTML": "<h3>Solidify Waste. Neutralize Odors. Instantly.</h3><p>Perfect for camping, RVs, and emergencies. Our high-performance absorbent powder turns liquid waste into a spill-proof gel in just 60 seconds, while powerful odor-neutralizing agents keep your environment fresh.</p><div class=\"product-features\">\n<h4>Why You’ll Love It:</h4>\n<ul>\n<li>\n<strong>Fast-Acting:</strong> Gels liquid in under a minute for easy, mess-free disposal.</li>\n<li>\n<strong>Odor Control:</strong> Neutralizes embarrassing smells at the source.</li>\n<li>\n<strong>Eco-Friendly:</strong> Biodegradable and safe for the environment.</li>\n<li>\n<strong>Travel-Ready:</strong> Lightweight and compact—essential for any adventure.</li>\n</ul>\n</div><div class=\"how-to-use\">\n<h4>How to Use:</h4>\n<ol>\n<li>Sprinkle a small amount of powder into the liquid waste container.</li>\n<li>Wait 60 seconds for the magic to happen.</li>\n<li>Once solidified, dispose of the gel in a standard waste bin.</li>\n</ol>\n</div>",
        "sourceImages": [
          "//cdn.shopify.com/s/files/1/0792/6585/7782/files/image_1_6cbd0163-c5ce-4ae2-862a-296088f0d4ab.jpg?v=1776243094"
        ],
        "variantImageIds": {
          "49913285345526": null,
          "49913285378294": null
        }
      }
    },
    {
      "id": "refill",
      "handle": null,
      "name": "Moisture Absorber Refill",
      "category": "home",
      "image": "assets/moisture-refill-cutout.png",
      "status": "comingsoon",
      "variants": [],
      "sourceEvidence": {
        "basis": "Fresh public Coming soon product page plus SDS001",
        "source": "https://www.acticlear.co/pages/acticlear-moisture-refill-commercial-v1",
        "publicProductVerified": true,
        "activePurchasableProductVerified": false
      }
    }
  ],
  "packOffers": [
    {
      "id": "compact-pack-2",
      "productId": "compact",
      "baseVariantId": 49913176064246,
      "shopifyProductId": 9505524809974,
      "variantId": 51547631550710,
      "handle": "acticlear-muck-clear-natural-0-5lb-2-pack",
      "title": "0.5lb / 2 packs",
      "packCount": 2,
      "price": 2469,
      "compareAtPrice": 2598,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-0-5lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-pack-3",
      "productId": "compact",
      "baseVariantId": 49913176064246,
      "shopifyProductId": 9505524875510,
      "variantId": 51547633352950,
      "handle": "acticlear-muck-clear-natural-0-5lb-3-pack",
      "title": "0.5lb / 3 packs",
      "packCount": 3,
      "price": 3509,
      "compareAtPrice": 3897,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-0-5lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-1lb-pack-2",
      "productId": "compact",
      "baseVariantId": 49913176097014,
      "shopifyProductId": 9505524908278,
      "variantId": 51547633385718,
      "handle": "acticlear-muck-clear-natural-1lb-2-pack",
      "title": "1lb / 2 packs",
      "packCount": 2,
      "price": 4179,
      "compareAtPrice": 4398,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-1lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-1lb-pack-3",
      "productId": "compact",
      "baseVariantId": 49913176097014,
      "shopifyProductId": 9505524973814,
      "variantId": 51547633811702,
      "handle": "acticlear-muck-clear-natural-1lb-3-pack",
      "title": "1lb / 3 packs",
      "packCount": 3,
      "price": 5939,
      "compareAtPrice": 6597,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-1lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-2lb-pack-2",
      "productId": "compact",
      "baseVariantId": 49913176129782,
      "shopifyProductId": 9505525006582,
      "variantId": 51547633844470,
      "handle": "acticlear-muck-clear-natural-2lb-2-pack",
      "title": "2lb / 2 packs",
      "packCount": 2,
      "price": 6269,
      "compareAtPrice": 6598,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-2lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-2lb-pack-3",
      "productId": "compact",
      "baseVariantId": 49913176129782,
      "shopifyProductId": 9505525039350,
      "variantId": 51547633877238,
      "handle": "acticlear-muck-clear-natural-2lb-3-pack",
      "title": "2lb / 3 packs",
      "packCount": 3,
      "price": 8909,
      "compareAtPrice": 9897,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-2lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-4lb-pack-2",
      "productId": "compact",
      "baseVariantId": 50113861353718,
      "shopifyProductId": 9505525072118,
      "variantId": 51547633910006,
      "handle": "acticlear-muck-clear-natural-4lb-2-pack",
      "title": "4lb / 2 packs",
      "packCount": 2,
      "price": 9499,
      "compareAtPrice": 9998,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-4lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "compact-4lb-pack-3",
      "productId": "compact",
      "baseVariantId": 50113861353718,
      "shopifyProductId": 9505525104886,
      "variantId": 51547633942774,
      "handle": "acticlear-muck-clear-natural-4lb-3-pack",
      "title": "4lb / 3 packs",
      "packCount": 3,
      "price": 13499,
      "compareAtPrice": 14997,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-natural-4lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "large-pack-2",
      "productId": "large",
      "baseVariantId": 49913279021302,
      "shopifyProductId": 9505525137654,
      "variantId": 51547633975542,
      "handle": "acticlear-muck-clear-beneficial-bacteria-5lb-2-pack",
      "title": "5lb / 2 packs",
      "packCount": 2,
      "price": 8169,
      "compareAtPrice": 8598,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-beneficial-bacteria-5lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "large-pack-3",
      "productId": "large",
      "baseVariantId": 49913279021302,
      "shopifyProductId": 9505525170422,
      "variantId": 51547634008310,
      "handle": "acticlear-muck-clear-beneficial-bacteria-5lb-3-pack",
      "title": "5lb / 3 packs",
      "packCount": 3,
      "price": 11609,
      "compareAtPrice": 12897,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-beneficial-bacteria-5lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "large-15lb-pack-2",
      "productId": "large",
      "baseVariantId": 49913279054070,
      "shopifyProductId": 9505525203190,
      "variantId": 51547634041078,
      "handle": "acticlear-muck-clear-beneficial-bacteria-15lb-2-pack",
      "title": "15lb / 2 packs",
      "packCount": 2,
      "price": 18999,
      "compareAtPrice": 19998,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-beneficial-bacteria-15lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "large-15lb-pack-3",
      "productId": "large",
      "baseVariantId": 49913279054070,
      "shopifyProductId": 9505525235958,
      "variantId": 51547634073846,
      "handle": "acticlear-muck-clear-beneficial-bacteria-15lb-3-pack",
      "title": "15lb / 3 packs",
      "packCount": 3,
      "price": 26999,
      "compareAtPrice": 29997,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-muck-clear-beneficial-bacteria-15lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "oil-pack-2",
      "productId": "oil",
      "baseVariantId": 49913164497142,
      "shopifyProductId": 9505499283702,
      "variantId": 51547519680758,
      "handle": "acticlear-cooking-oil-solidifier-11oz-2-pack",
      "title": "11oz / 2 packs",
      "packCount": 2,
      "price": 1899,
      "compareAtPrice": 1998,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-cooking-oil-solidifier-11oz-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "oil-pack-3",
      "productId": "oil",
      "baseVariantId": 49913164497142,
      "shopifyProductId": 9505499676918,
      "variantId": 51547521253622,
      "handle": "acticlear-cooking-oil-solidifier-11oz-3-pack",
      "title": "11oz / 3 packs",
      "packCount": 3,
      "price": 2699,
      "compareAtPrice": 2997,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-cooking-oil-solidifier-11oz-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "oil-22oz-pack-2",
      "productId": "oil",
      "baseVariantId": 49913164529910,
      "shopifyProductId": 9505499709686,
      "variantId": 51547521286390,
      "handle": "acticlear-cooking-oil-solidifier-22oz-2-pack",
      "title": "22oz / 2 packs",
      "packCount": 2,
      "price": 2849,
      "compareAtPrice": 2998,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-cooking-oil-solidifier-22oz-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "oil-22oz-pack-3",
      "productId": "oil",
      "baseVariantId": 49913164529910,
      "shopifyProductId": 9505499742454,
      "variantId": 51547521319158,
      "handle": "acticlear-cooking-oil-solidifier-22oz-3-pack",
      "title": "22oz / 3 packs",
      "packCount": 3,
      "price": 4049,
      "compareAtPrice": 4497,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-cooking-oil-solidifier-22oz-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "pee-pack-2",
      "productId": "pee",
      "baseVariantId": 49913285345526,
      "shopifyProductId": 9505525268726,
      "variantId": 51547634106614,
      "handle": "acticlear-pee-powder-2lb-2-pack",
      "title": "2lb / 2 packs",
      "packCount": 2,
      "price": 4179,
      "compareAtPrice": 4398,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-pee-powder-2lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "pee-pack-3",
      "productId": "pee",
      "baseVariantId": 49913285345526,
      "shopifyProductId": 9505525301494,
      "variantId": 51547634139382,
      "handle": "acticlear-pee-powder-2lb-3-pack",
      "title": "2lb / 3 packs",
      "packCount": 3,
      "price": 5939,
      "compareAtPrice": 6597,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-pee-powder-2lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "pee-4lb-pack-2",
      "productId": "pee",
      "baseVariantId": 49913285378294,
      "shopifyProductId": 9505525334262,
      "variantId": 51547634303222,
      "handle": "acticlear-pee-powder-4lb-2-pack",
      "title": "4lb / 2 packs",
      "packCount": 2,
      "price": 7599,
      "compareAtPrice": 7998,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-pee-powder-4lb-2-pack",
      "sourceLabel": "2 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    },
    {
      "id": "pee-4lb-pack-3",
      "productId": "pee",
      "baseVariantId": 49913285378294,
      "shopifyProductId": 9505525399798,
      "variantId": 51547634368758,
      "handle": "acticlear-pee-powder-4lb-3-pack",
      "title": "4lb / 3 packs",
      "packCount": 3,
      "price": 10799,
      "compareAtPrice": 11997,
      "available": true,
      "currency": "USD",
      "source": "https://www.acticlear.co/products/acticlear-pee-powder-4lb-3-pack",
      "sourceLabel": "3 packs",
      "imageNote": "Resolve the genuine single-package image by baseVariantId. Pack count is stated separately; no multiplied package photograph is claimed."
    }
  ],
  "catalogMode": "verified-offline-snapshot"
};
